import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onBeforeMount, ref } from "vue";
// Composables
import { useColors } from "@/common/composables/colors";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecCardTitle',
    props: {
        color: { default: "primary" }
    },
    setup(__props) {
        const props = __props;
        // Props validation
        const { isValidMDColor } = useColors();
        const colorPropIsValid = ref(false);
        onBeforeMount(async () => {
            colorPropIsValid.value = await isValidMDColor(props.color);
            if (!colorPropIsValid.value) {
                console.warn(`"${props.color}" passed to RecCardSubtitle's "color" prop is not a valid MD color`);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['rec-card-title', { [`text-${colorPropIsValid.value ? _ctx.color : 'primary'}`]: true }])
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2));
        };
    }
});
